import { useMutation } from '@tanstack/react-query';
import { configApi } from '../../configApi';

export interface IFile {
  id: string;
  file: File;
}

interface IPayload {
  detail?: string;
  examination_board_id?: string;
  examination_board_member_id?: string;
  nis?: string;
  redome_code?: string;
  questionNumber?: string;
  proof_subject?: string;
  title_item?: string;
}

export interface IUpdateResourcePayload {
  attachmentFile?: IFile[];
  removeAttachmentFileIds?: string[];
  payload?: IPayload;
}

const updateResource = async (resourceId: string, data: IUpdateResourcePayload) => {
  const formData = new FormData();

  if (data.attachmentFile && data.attachmentFile.length > 0) {
    data.attachmentFile.forEach((files) => {
      formData.append('resource_files', files.file);
    });
  }

  if (data.removeAttachmentFileIds && data.removeAttachmentFileIds?.length > 0) {
    data.removeAttachmentFileIds.forEach((id) => {
      formData.append('remove_attachment_file_ids', id);
    });
  }

  if (data.payload?.detail) {
    formData.append('observation', data.payload?.detail);
  }

  if (data.payload?.examination_board_id) {
    formData.append('examination_board', data.payload?.examination_board_id);
  }

  if (data.payload?.examination_board_member_id) {
    formData.append('examination_board_member', data.payload?.examination_board_member_id);
  }

  if (data.payload?.nis) {
    formData.append('nis', data.payload?.nis);
  }

  if (data.payload?.redome_code) {
    formData.append('redome', data.payload?.redome_code);
  }

  if (data.payload?.questionNumber) {
    formData.append('question', data.payload?.questionNumber);
  }

  if (data.payload?.proof_subject) {
    formData.append('proof_subject', data.payload?.proof_subject);
  }

  if (data.payload?.title_item) {
    formData.append('title_item', data.payload?.title_item);
  }

  const response = await configApi.patch(`resources/update/${resourceId}/`, formData);
  return response;
};

export const useUpdateResource = (resourceId: string) => {
  return useMutation({
    mutationFn: (data: IUpdateResourcePayload) => updateResource(resourceId, data),
    mutationKey: ['updateResource', resourceId],
  });
};
